import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import {
  CardCategoryStyled,
  CardCategoryWrapper,
  CardContainer,
  NavigationButton,
} from "../styled"
import { categories } from "../data/productsData"
import SvgIcon from "src/components/SvgIcon"

const CardCategory = ({ selectedCategories = [], excludeCategory }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [currentIndex, setCurrentIndex] = useState(0)
  const navigate = useNavigate();
  const filteredCategories = selectedCategories.length
  ? categories.filter(c => selectedCategories.includes(c.id) && c.id !== excludeCategory)
  : categories.filter(c => c.id !== excludeCategory);


  const itemsPerPage = windowWidth < 768 ? 2 : 4
  const shouldHideNav =
    windowWidth > 768 && filteredCategories.length <= itemsPerPage

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const visibleCategories = filteredCategories.slice(
    currentIndex,
    currentIndex + itemsPerPage,
  )

  const handlePrev = () => {
    setCurrentIndex(prevIndex => Math.max(prevIndex - itemsPerPage, 0));
  };

  const handleNext = () => {
    setCurrentIndex(prevIndex => {
      const nextIndex = prevIndex + itemsPerPage;
      return nextIndex < filteredCategories.length ? nextIndex : prevIndex;
    });
  };
  const handleCategoryClick = (categoryId) => {
    navigate(`/chi-tiet-phan-he/${categoryId}`);
  };

  return (
    <CardCategoryWrapper>
      <CardContainer>
        {!shouldHideNav && filteredCategories.length > itemsPerPage && (
          <NavigationButton left onClick={handlePrev}>
            <SvgIcon name="arrow-left-white" />
          </NavigationButton>
        )}

        {visibleCategories.map(category => (
          <CardCategoryStyled key={category.id} hoverable onClick={() => handleCategoryClick(category.id)}>
            <img
              className="card-image"
              src={category.image}
              alt={category.title}
            />
            <div className="card-content">
              <h3 className="card-title">{category.title}</h3>
            </div>
          </CardCategoryStyled>
        ))}

        {!shouldHideNav && filteredCategories.length > itemsPerPage && (
          <NavigationButton right onClick={handleNext}>
            <SvgIcon name="arrow-right-white" />
          </NavigationButton>
        )}
      </CardContainer>
    </CardCategoryWrapper>
  )
}

export default CardCategory
